module.exports = __webpack_public_path__ + "img/restart.92db7e4a.svg";